import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../../../data/api';
import Toast from '../../../utils/toastManager';
import TRC_PAGE_CATEGORIES from '../../constants/trcCategories';
import ResourcesGrid from '../Resources/components/grid';
import MobileTopSectionWithFilter from '@/TRC/components/TopSections/mobileTopSectionWithFilter';
import TopSectionWithFilter from '@/TRC/components/TopSections/topSectionWithFilter';
import { useAtomValue } from 'jotai';
import { userInfoAtom } from '@/data/atoms/utilsAtoms';
import { isStudioUser } from '@/utils/isStudioUser';

const TRCSearchPage = () => {
	const [responseData, setResponseData] = useState([]);
	const location = useLocation();
	const userData = useAtomValue(userInfoAtom);
	const isStudioHub = isStudioUser(userData);

	const fetchSearchResults = async searchquery => {
		try {
			const [trcResponse, lessonPlanResponse] = await Promise.all([
				api.searchContent(searchquery),
				isStudioHub ? api.getLessonPlans() : Promise.resolve({ data: [] })
			]);

			const trcResults = trcResponse?.data || [];
			const lowerQuery = searchquery.toLowerCase();
			const stripHtml = str => str?.replace(/<[^>]*>/g, '') || '';
			const matchedLessonPlans = (lessonPlanResponse?.data || [])
				.filter(p =>
					p.title?.toLowerCase().includes(lowerQuery) ||
					stripHtml(p.about).toLowerCase().includes(lowerQuery)
				)
				.map(plan => ({
					...plan,
					fileType: 'pdf',
					categoryDetails: [
						{ _id: 'studio-lesson-plan', name: 'Progressive Lesson Plan', color: '#008bc3' },
						...(plan.categoriesDetails || [])
					]
				}));

			setResponseData([...trcResults, ...matchedLessonPlans]);
		} catch (error) {
			Toast.error(error.message || 'Error fetching search results:');
		}
	};

	useEffect(() => {
		const searchquery = new URLSearchParams(location.search).get('search_query');
		if (searchquery) {
			fetchSearchResults(searchquery);
		}
	}, [location.search, isStudioHub]);

	return (
		<div className="d-flex flex-column gap-2 pt-lg-0">
			<MobileTopSectionWithFilter
				contents={responseData}
				setContents={setResponseData}
				category={TRC_PAGE_CATEGORIES.SEARCH}
			/>
			<TopSectionWithFilter
				setContents={setResponseData}
				contents={responseData}
				category={TRC_PAGE_CATEGORIES.SEARCH}
			/>
			<ResourcesGrid contents={responseData} />
		</div>
	);
};

export default TRCSearchPage;
